import { useAtomValue, useSetAtom } from 'jotai';

import { FiltersDrawerRangeSection } from '@common/components/FilterGroups/FiltersDrawerRangeSection';

import { estRetailPriceRangeAtom, updateEstRetailPriceRangeAtom } from '../../atoms/preordersAtoms';

export function FiltersDrawerEstRetailPriceSection(): React.JSX.Element {
	const committedRange = useAtomValue(estRetailPriceRangeAtom);
	const setRange = useSetAtom(updateEstRetailPriceRangeAtom);

	return (
		<FiltersDrawerRangeSection
			title='Est. retail price'
			description='Filter by estimated retail price range'
			value={committedRange}
			onChange={setRange}
		/>
	);
}
